import { Suspense } from 'react';

import { Route } from 'react-router-dom';

import { SuspenseLoader } from 'components/loaders';

import { OneClickPageErrorBoundary } from './OneClickPageErrorBoundary';
import type { OneClickLinkItem } from './types';

type RenderConfigRoutesArgs = {
  pages: OneClickLinkItem[];
  suspense?: boolean;
};

export const renderConfigRoutes = ({
  pages,
  suspense = true,
}: RenderConfigRoutesArgs) =>
  pages.map(({ route, page: Page }) => {
    let element = (
      <OneClickPageErrorBoundary>
        <Page />
      </OneClickPageErrorBoundary>
    );

    if (suspense) {
      element = <Suspense fallback={<SuspenseLoader />}>{element}</Suspense>;
    }

    if (route === '') {
      return <Route key="index" index element={element} />;
    }

    return <Route key={route} path={route} element={element} />;
  });
